import React, { useMemo, useState } from 'react';
import { Helmet } from "react-helmet-async";
import {
    ConfigProvider,
    theme,
    Table,
    Input,
    Avatar,
    Tag,
    Button,
    Tooltip,
    Modal
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import {
    Minus, Plus, CircleChevronDown, Funnel,
    Phone, Clock, MessageSquareDashed, Paperclip, Smile, Send,
    CircleArrowUp, Undo2, RefreshCw, UserRoundPlus,
    CirclePercent, Bot, Check, CircleHelp, Waypoints, PenTool, Mail,
    CircleX, Play, HelpCircle,
    X,
    File,
    ChevronDown,
    PencilLine,
    Trash,
    SquareArrowUpRight
} from 'lucide-react';

import Layout from '../../Layout'; // Giữ nguyên import layout của bạn
import { Link } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { mixformatCurrency } from 'services/mixin';
import { ModalEditSignature } from './components/ModalEdit';

const { TextArea } = Input;

interface HistoryItem {
    status: number;
}

interface ExpenseDetail {
    status: number,
    step: number,
    history: HistoryItem[],
}

const tabs = [
    { id: 1, label: 'Lịch sử hoạt động' },

]


export default function DigitalSignDetail() {

    const [isDarkMode, setIsDarkMode] = useState(false);
    const [tab, setTab] = useState(1)
    const [showModalEdit, setShowModalEdit] = useState(false)

    // ================= DỮ LIỆU MOCK =================
    const [detail, setDetail] = useState<ExpenseDetail>({
        status: 1,
        step: 1,
        history: [
            { status: 1 }
        ],
    });


    // ====Collapse States====
    const [expandedBlocks, setExpandedBlocks] = useState({
        general: true,
        salary: true,
        history: true,
    });

    const toggleBlock = (key: keyof typeof expandedBlocks) => {
        setExpandedBlocks(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const CardHeader = ({ title, blockKey, extra }: { title: any, blockKey: keyof typeof expandedBlocks, extra?: any }) => (
        <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
            <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
            <div className="flex items-center gap-3">
                {extra}
                <div onClick={() => toggleBlock(blockKey)} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                    {expandedBlocks[blockKey] ? <Minus size={16} /> : <Plus size={16} />}
                </div>
            </div>
        </div>
    );

    const Header = ({ title }: { title: any }) => (
        <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 px-4 py-2 -mx-4 -mt-4">
            <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
        </div>
    );

    return (
        <Layout>
            <Helmet>
                <title> Chi tiết ký số | Khothi</title>
            </Helmet>
            <div className="flex gap-2 mb-4 justify-between items-center">
                <h2 className="text-lg text-gray-900 font-semibold dark:text-white">
                    Chi tiết ký số
                </h2>
                {/* <button className="flex items-center gap-2 px-3 py-1.5 bg-[#3e91ab] text-white rounded text-sm font-medium hover:bg-[#357f96] transition-colors" onClick={() => navigate(`/employment-contract/add`)}>
                    <Plus size={16} /> Thêm mới
                </button> */}
            </div>
            <ConfigProvider>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* --- HEADER ACTIONS --- */}
                    <div className="border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">
                        <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                            <div className="flex sm:items-center gap-4 text-sm items-start">
                                <Link to="/digital-signature" className="flex items-center gap-2">
                                    <LeftOutlined className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white" />
                                </Link>
                                <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-1 cursor-pointer">Thông tin chung</span>
                            </div>
                        </div>

                        <div className='overflow-x-auto no-scrollbar'>
                            <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max text-000000e0">
                                {/* <Button type="primary" icon={<Bot size={18} />}>
                                    1AI Monitor
                                </Button> */}
                                {/* <button className="text-sm flex items-center gap-1.5 hover:text-[#3e91ab]"><Check size={14} /> Duyệt</button> */}
                                <button onClick={() => setShowModalEdit(true)} className="text-sm flex items-center gap-1.5 hover:text-[#3e91ab]"><PencilLine size={14} /> Sửa</button>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><Trash size={14} /> Xóa</button>
                                {/* <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><File size={14} /> Biểu mẫu <ChevronDown size={14} /></button> */}
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] text-sm"><CircleChevronDown size={20} /></button>
                            </div>
                        </div>
                    </div>

                    {/* --- MAIN LAYOUT --- */}
                    <div className="mx-auto mt-4 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4">

                        {/* CỘT TRÁI CÓ TABS CHÍNH */}
                        <div className="min-w-0 overflow-hidden">
                            <div className="flex flex-col gap-6 pt-0">

                                {/* 1 */}
                                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                    <CardHeader title="Thông tin chung" blockKey="general" />
                                    {expandedBlocks.general && (
                                        <>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 text-[14px] mt-4 mb-6">
                                                {/* Cột 1 */}
                                                <div className="flex flex-col gap-5">
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Tên chữ ký</p>
                                                        <p className="text-gray-800 dark:text-gray-200">MAIDUNG</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Mặc định</p>
                                                        <p className="text-gray-800 dark:text-gray-200">Không</p>
                                                    </div>

                                                </div>
                                                {/* Cột 2 */}
                                                <div className="flex flex-col gap-5">

                                                    <div>
                                                        <p className="text-gray-400 mb-1">Nhà cung cấp</p>
                                                        <div className="flex flex-col gap-2">
                                                            <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#f4f4f4] dark:bg-[#111827] w-fit">
                                                                <Avatar size={20} className="bg-gray-500 text-[10px]" src='https://trial.1office.vn/f/p/TDI0OHljd045SHpkUkF0d2REV0NRQ1pCZlJnU1dQUGZoTm5rT0dRMWVpYmFiREZsL2lDd1dNTFJwbEtUbnJjdVZVWkZ6T2FWU2ZSNkszZVpyeWxxWENWU29kQnBnNEgzWGM5NjVEL0xGNHVUSUNOWDRsaz0/1535570912638031ae4eb2b025045322.25.11.2022.small.png' />
                                                                <span className="text-gray-800 dark:text-gray-200">Office</span>
                                                            </div>
                                                            {/* <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#f4f4f4] dark:bg-[#111827] w-fit">
                                                                <Avatar size={20} className="bg-gray-500 text-[10px]" src='https://trial.1office.vn/f/p/TDI0OHljd045SHpkUkF0d2REV0NRQ1pCZlJnU1dQUGZoTm5rT0dRMWVpYmFiREZsL2lDd1dNTFJwbEtUbnJjdVZVWkZ6T2FWU2ZSNkszZVpyeWxxWENWU29kQnBnNEgzWGM5NjVEL0xGNHVUSUNOWDRsaz0/1535570912638031ae4eb2b025045322.25.11.2022.small.png' />
                                                                <span className="text-gray-800 dark:text-gray-200">Lê Tuấn Anh</span>
                                                            </div>
                                                            <span className="text-[#3E91AB] cursor-pointer text-xs font-medium">Xem thêm (+2)</span> */}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Ngày tạo</p>
                                                        <p className="text-gray-800 dark:text-gray-200">12:10 11/09/206</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Thông tin tài khoản */}
                                            <Header title='Thông tin tài khoản' />
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 text-[14px] mt-4 mb-6">
                                                {/* Cột 1 */}
                                                <div className="flex flex-col gap-5">
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Nhà cung cấp</p>
                                                        <p className="text-gray-800 dark:text-gray-200">ABC</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Số chứng minh nhân dân</p>
                                                        <p className="text-gray-800 dark:text-gray-200">08138131723192</p>
                                                    </div>

                                                </div>
                                                {/* Cột 2 */}
                                                <div className="flex flex-col gap-5">
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Họ và tên</p>
                                                        <p className="text-gray-800 dark:text-gray-200">MAI DUNG</p>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Thông tin serial */}
                                            <Header title='0x08138131723192SADA12141241' />
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 text-[14px] mt-4 mb-6">
                                                {/* Cột 1 */}
                                                <div className="flex flex-col gap-5">
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Serial</p>
                                                        <p className="text-gray-800 dark:text-gray-200">0x08138131723192SADA12141241</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Ngày hết hạn</p>
                                                        <p className="text-gray-800 dark:text-gray-200">21/09/2027</p>
                                                    </div>

                                                </div>
                                                {/* Cột 2 */}
                                                <div className="flex flex-col gap-5">
                                                    <div>
                                                        <p className="text-gray-400 mb-1">Ngày cấp</p>
                                                        <p className="text-gray-800 dark:text-gray-200">11/09/2026</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>

                        {/* CỘT PHẢI (THẢO LUẬN / LỊCH SỬ) - Giữ nguyên logic cũ */}
                        <div className="min-w-0 flex flex-col gap-4 h-full">
                            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 md:p-6 border dark:border-gray-700">
                                <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
                                    <div className="flex sm:items-center gap-4 text-sm sm:flex-row flex-col items-start">
                                        {tabs.map((item) => (
                                            <button
                                                type="button"
                                                onClick={() => setTab(item.id)}
                                                className={`font-medium pb-1 border-b-2 transition-colors ${item.id === tab
                                                    ? "text-[#3e91ab] border-[#3e91ab]"
                                                    : "text-gray-500 dark:text-gray-400 border-transparent"
                                                    }`}
                                            >
                                                {item.label}
                                            </button>
                                        ))}
                                    </div>
                                    <div className='flex gap-2'>
                                        <div className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                                        <Funnel size={16}/>
                                        </div>
                                        <div onClick={() => toggleBlock('history')} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                                            {expandedBlocks['history'] ? <Minus size={16} /> : <Plus size={16} />}
                                        </div>
                                    </div>
                                </div>
                                {expandedBlocks.history && (
                                    <div className="pb-4 mt-4">
                                        {/* Khung chứa Timeline */}
                                        <div className="relative pl-6 space-y-4 max-h-[450px] overflow-y-auto pr-1">

                                            {/* Trục dọc (Đường line màu xám chạy dọc timeline) */}
                                            <div className="absolute left-[11px] top-3 bottom-3 w-0.5 bg-gray-200 dark:bg-gray-700"></div>

                                            {/* --- ITEM TIMELINE 1 --- */}
                                            <div className="relative flex items-start group">
                                                {/* Icon tròn màu hồng đậm bên trái */}
                                                <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#ec4899] text-white flex items-center justify-center shadow-sm z-9">
                                                    <PencilLine size={12} />
                                                </div>
                                                {/* Card nội dung */}
                                                <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <div className='flex gap-1 items-center'>
                                                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">MAIDUNG</span> <span className="text-gray-500">đã sửa</span>
                                                                </p>
                                                                <SquareArrowUpRight size={12} color='#4577D2' />
                                                            </div>
                                                            <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                <span className="mr-1"></span> 17:26 ng 25/06/2026
                                                            </p>
                                                            <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                ID: 3443 - MAIDUNG
                                                            </p>
                                                        </div>
                                                        {/* Avatar chữ B bên phải */}
                                                        <div className="w-8 h-8 rounded-full bg-orange-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                           D
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* --- ITEM TIMELINE 3 --- */}
                                            <div className="relative flex items-start group">
                                                {/* Icon tròn màu xanh lá bên trái */}
                                                <div className="absolute -left-6 top-2 w-6 h-6 rounded-full bg-[#10b981] text-white flex items-center justify-center shadow-sm z-9">
                                                    <Plus size={12} />
                                                </div>
                                                {/* Card nội dung */}
                                                <div className="flex-1 bg-[#f8f9fa] dark:bg-gray-800 p-4 rounded-md border border-gray-100 dark:border-gray-700 relative ml-2">
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <div className='flex gap-1 items-center'>
                                                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                                                    <span className="font-bold">MAIDUNG</span> <span className="text-gray-500">đã tạo mới</span>
                                                                </p>
                                                                {/* <SquareArrowUpRight size={12} color='#4577D2' /> */}
                                                            </div>
                                                            <p className="text-[11px] text-gray-400 mt-0.5 flex items-center">
                                                                <span className="mr-1"></span> 17:25 ng 25/06/2026
                                                            </p>
                                                            <p className="text-[12px] text-gray-600 dark:text-gray-400 mt-2">
                                                                ID: 3443 - MAIDUNG
                                                            </p>
                                                        </div>
                                                        {/* Avatar chữ B bên phải */}
                                                        <div className="w-8 h-8 rounded-full bg-orange-400 text-white flex items-center justify-center text-xs font-bold shrink-0 ml-3">
                                                           D
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* MODAL */}
                        <ModalEditSignature open={showModalEdit} onCancel={() => setShowModalEdit(false)}/>
                    </div>

                </div>
            </ConfigProvider>
        </Layout>
    );
}